<template>
    <div class="notification" :class="classes" role="alert">
      <slot></slot>
    </div>
</template>
<script>

import { computed } from 'vue';

export default {
  props: {
    class: {
      required: false,
    },
    type: {
      required: true,
    },

  },
  components: {
    // CheckCircleIcon, LoaderIcon, XCircleIcon
  },
  // setup(props, { emit }) {
  setup(props) {
    const classes = computed(() => {

      let classArray = ['notification']

      if(props.type === 'error') {
        classArray.push('is-danger')

      } else if(props.type === 'success') {
        classArray.push('is-success')
      }

      classArray.push(props.class)
      return classArray.join(' ')
    })

    return { classes }
  },
};
</script>
<style lang="scss" scoped>

</style>